"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserGroupFormContent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/components/form-parts/form/component");
const component_2 = require("@front/components/site-menu/component");
//@ts-ignore                
let rwsTemplate = T.html `
    <the-form :onSubmit="${(x, c) => x.saveUserGroup.bind(x)}">
        
        <div class="form-group${x => x.isModalMode ? ' mt-3' : ''}">
            <part-input class="form-part" label="${'userGroup.form.name.label'.t()}"
                :value="${x => x.form.name}" name="name"
                placeholder="${'userGroup.form.name.placeholder'.t()}" required="true"></part-input>
        </div>

        <div class="form-group">
            <part-textarea class="form-part" label="${'userGroup.form.description.label'.t()}"
                :value="${x => x.form.description}" name="description"
                placeholder="${'userGroup.form.description.placeholder'.t()}"
                rows="3"></part-textarea>
        </div>

        <div class="mb-4">
            <div class="form-check">
                <part-checkbox class="form-part" label="${'userGroup.form.active.label'.t()}"
                    :value="${x => x.form.active}" name="active"></part-checkbox>
            </div>
        </div>

        
        <div class="form-group col-lg-12">
            <h5>${'userGroup.form.acl.label'.t()}</h5>
            <p class="text-muted">${'userGroup.form.acl.description'.t()}</p>
            <acl-checkboxes :resources="${x => x.resources}" :roles="${x => x.roles}"
                :value="${x => x.form.policyEntry}" name="acl"
                :onACLChanged="${(x, c) => x.onACLChanged.bind(x)}"></acl-checkboxes>
        </div>

        <div class="form-group mt-4">
            <button @click="${(x, c) => x.sendSubmit(x, c)}" class="btn btn-primary btn-lg mr-2"
                ?disabled="${x => x.loading}">
                ${x => x.userGroupId ? 'userGroup.form.submit.update'.t() :
    'userGroup.form.submit.create'.t()}
            </button>
            
            ${(0, fast_element_1.when)(x => x.isModalMode, (0, fast_element_1.html) `
                <button type="button" @click="${(x, c) => x.onCancel()}" class="btn btn-secondary btn-lg">
                    ${'common.cancel'.t()}
                </button>
            `)}
        </div>
    </the-form>
`;
const styles = null;
const shadowOptions = { "mode": "open" };
let UserGroupFormContent = class UserGroupFormContent extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.userGroupId = null;
        this.userGroup = null;
        this.resources = {};
        this.roles = {};
        this.companyId = null;
        this.isModalMode = false;
        this.form = {
            name: '',
            description: '',
            active: true,
            policyEntry: {},
            companyId: null
        };
        this.sendSubmit = component_1.FormComponent.sendSubmitEvent;
    }
    async connectedCallback() {
        super.connectedCallback();
        console.log(this.userGroupId);
        if (this.userGroupId) {
            await this.loadUserGroup();
        }
        await this.loadACLMeta();
        if (this.companyId) {
            this.form = {
                ...this.form,
                companyId: this.companyId
            };
        }
        component_1.FormComponent.listenForValuesChange.bind(this)('form');
    }
    async loadUserGroup() {
        var _a;
        if (!this.userGroupId)
            return;
        this.loading = true;
        try {
            const response = await this.apiService.back.get('user-group.get', {
                routeParams: { id: this.userGroupId.toString() }
            });
            if (response.success && response.data) {
                this.userGroup = response.data;
                this.form = {
                    name: response.data.name,
                    description: response.data.description || '',
                    active: response.data.active,
                    policyEntry: ((_a = response.data.policy) === null || _a === void 0 ? void 0 : _a.policyEntry) || {}
                };
            }
            else {
                console.error('Failed to load user group:', response.error);
            }
        }
        catch (error) {
            console.error('Error loading user group:', error);
        }
        finally {
            this.loading = false;
        }
    }
    async loadACLMeta() {
        try {
            const meta = await this.apiService.back.get('acl-policy.meta');
            if (meta.success && meta.data) {
                this.resources = meta.data.resources;
                this.roles = meta.data.roles;
            }
        }
        catch (error) {
            console.error('Error loading ACL meta:', error);
        }
    }
    async saveUserGroup() {
        var _a;
        if (this.loading)
            return;
        // Validate required fields
        if (!((_a = this.form.name) === null || _a === void 0 ? void 0 : _a.trim())) {
            return;
        }
        this.loading = true;
        try {
            const endpoint = this.userGroupId ? 'user-group.update' : 'user-group.create';
            const params = this.userGroupId ? { routeParams: { id: this.userGroupId } } : {};
            const sendFn = this.userGroupId ? this.apiService.back.put.bind(this.apiService.back) : this.apiService.back.post.bind(this.apiService.back);
            const response = await sendFn(endpoint, this.form, params);
            if (response.success) {
                this.notifyService.notify('userGroup.form.saved'.t(), 'info');
                // Emit event for modal mode or navigate for page mode
                if (this.isModalMode) {
                    this.$emit('user-group-saved', { userGroup: response.data });
                }
                else {
                    component_2.SiteMenu.goto.bind(this)('/user-group/list');
                }
            }
            else {
                console.error('Failed to save user group:', response);
                this.notifyService.notify(response.error || 'userGroup.form.error.save'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Error saving user group:', error);
            this.notifyService.notify('userGroup.form.error.save'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    onACLChanged(policy) {
        this.form.policyEntry = { ...policy };
    }
    onCancel() {
        if (this.isModalMode) {
            this.$emit('cancel');
        }
        else {
            this.goBack();
        }
    }
    goBack() {
        component_2.SiteMenu.goto.bind(this)('/user-group/list');
    }
};
exports.UserGroupFormContent = UserGroupFormContent;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], UserGroupFormContent.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], UserGroupFormContent.prototype, "userGroupId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof backendImport_1.IUserGroup !== "undefined" && backendImport_1.IUserGroup) === "function" ? _a : Object)
], UserGroupFormContent.prototype, "userGroup", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof Record !== "undefined" && Record) === "function" ? _b : Object)
], UserGroupFormContent.prototype, "resources", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof Record !== "undefined" && Record) === "function" ? _c : Object)
], UserGroupFormContent.prototype, "roles", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], UserGroupFormContent.prototype, "companyId", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Boolean)
], UserGroupFormContent.prototype, "isModalMode", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof backendImport_1.IUserGroupPayload !== "undefined" && backendImport_1.IUserGroupPayload) === "function" ? _d : Object)
], UserGroupFormContent.prototype, "form", void 0);
exports.UserGroupFormContent = UserGroupFormContent = __decorate([
    (0, client_1.RWSView)('user-group-form-content', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], UserGroupFormContent);
UserGroupFormContent.defineComponent();
